<template>
	<div class="app-timeline flex flex-1 flex-col md:flex-row">
		<div class="app-timeline-step flex flex-1 py-2 relative" v-for="step in steps" :key="step.index">
			<div
				v-if="step.index < steps.length"
				class="absolute z-10 border-l-1 h-full w-0 ml-3 md:border-t-1 md:w-full md:h-0 md:mt-3 "
				:class="{
					'border-info': step.index < currentStep,
					'border-secondary': step.index >= currentStep,
				}"
			/>
			<div
				class="rounded-full z-50 border-1 w-6 h-6 items-center justify-center content-center align-middle text-center"
				:class="{
					'border-info': step.index <= currentStep,
					'bg-info': step.index === currentStep,
					'bg-white': step.index !== currentStep,
					'border-secondary': step.index > currentStep,
				}"
			>
				<app-icon
					icon="save"
					v-if="step.index < currentStep"
					:class="{ 'text-info': step.index < currentStep }"
				/>
				<span
					v-else
					:class="{
						'text-white': step.index === currentStep,
						'text-secondary': step.index > currentStep,
					}"
				>
					{{ step.index }}
				</span>
			</div>
			<div class="flex flex-row md:flex-col items-center md:items-start z-50 bg-white md:mt-1">
				<span class="font-bold text-13 mr-2">&nbsp;{{ step.title }}</span>
				<span>{{ step.text }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import AppIcon from '@/components/app/AppIcon';

	export default {
		name: 'AppTimeline',
		props: {
			steps: {
				required: true,
				type: Array,
			},
			currentStep: {
				required: true,
				type: Number,
			},
		},
		components: {
			AppIcon,
		},
	};
</script>
